import React from 'react'
import { Tabs as TabsContainer } from 'react-tabs'
import { List } from './List'
import { Panel } from './Panel'
import { Tab } from './Tab'
import * as S from './styled'
import type { TabsProps } from './types'

export const Tabs = ({ direction = 'horizontal', defaultIndex, children, onSelect }: TabsProps) => {
  return (
    <S.Container $direction={direction}>
      <TabsContainer defaultIndex={defaultIndex} onSelect={onSelect}>
        {children}
      </TabsContainer>
    </S.Container>
  )
}

Tabs.Item = Tab
Tabs.Panel = Panel
Tabs.List = List
